<template>
  <div class="where">
    <h2>Travel Experience</h2>
    <p class="highlight-tex">For our Worldwide Sales Departments, a strong worldwide geographical awareness is needed as well as extensive and recent first-hand travel experience, with particular preference for travel experience within Australia & New Zealand, America & Canada or Asia. <br><br>   
    <span class="highlight-text">Please indicate where, when and how long you have travelled in the below regions. <br>
      If you have not travelled to one of the below regions, please leave it blank.
    </span>
    </p>
    <!-- Form -->
    <b-form>
      <!-- Australasia -->
      <b-form-group
        label="Australasia"
      >
        <b-form-textarea
          :value="recruit.whereBeen.whereAustralasia"
          @input="handleInput('whereAustralasia', $event, true)"
        ></b-form-textarea>
      </b-form-group>
      <!-- Asia -->
      <b-form-group
        label="Asia"
      >
        <b-form-textarea
          :value="recruit.whereBeen.whereAsia"
          @input="handleInput('whereAsia', $event, true)"
        ></b-form-textarea>
      </b-form-group>
      <!-- Africa -->
      <b-form-group
        label="Africa"
      >
        <b-form-textarea
          :value="recruit.whereBeen.whereAfrica"
          @input="handleInput('whereAfrica', $event, true)"
        ></b-form-textarea>
      </b-form-group>
      <!-- North America -->
      <b-form-group
        label="North America"
      >
        <b-form-textarea
          :value="recruit.whereBeen.whereNorthAmerica"
          @input="handleInput('whereNorthAmerica', $event, true)"
        ></b-form-textarea>
      </b-form-group>
      <!-- South America -->
      <b-form-group
        label="South America"
      >
        <b-form-textarea
          :value="recruit.whereBeen.whereSouthAmerica"
          @input="handleInput('whereSouthAmerica', $event, true)"
        ></b-form-textarea>
      </b-form-group>
      <!-- Europe -->
      <!-- <b-form-group
        label="Europe"
      >
        <b-form-textarea
          :value="recruit.whereBeen.whereEurope"
          @input="handleInput('whereEurope', $event, true)"
        ></b-form-textarea>
      </b-form-group> -->
      <!-- <BtnMain @btnClicked="handleProgress" text="Save and progress" btnClass="progress-btn" variant="dark" /> -->
    </b-form>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { updateForm } from '../../helpers/index'
// import BtnMain from '../../components/BtnMain'
export default {
  components: {
    // BtnMain
  },
  computed: {
    ...mapState({recruit: state => state.authStore.recruit}),
    ...mapGetters({
      getRecruit: 'authStore/getRecruit',
      getSectionOpen: 'authStore/getSectionOpen',
      getWhereBeenValidated: 'authStore/getWhereBeenValidated'
    })
  },
  data () {
    return {
      sectionValidated: false
    }
  },
  updated () {
    // Track section validation - section is valid as long as one input is populated
      if (
        this.recruit.whereBeen.whereAfrica ||
        this.recruit.whereBeen.whereAustralasia ||
        this.recruit.whereBeen.whereAsia ||
        this.recruit.whereBeen.whereNorthAmerica ||
        this.recruit.whereBeen.whereSouthAmerica 
        // || this.recruit.whereBeen.whereEurope
      ) {
        this.whereBeenValidatedAction(true)
      } else {
        this.whereBeenValidatedAction(false)
      }
    // Pass validation status to vuex
    const validationData = {
      section: 'where',
      status: this.getWhereBeenValidated
    }
    this.updateApplicationCompleteAction(validationData)
  },
  methods: {
    ...mapActions({
      updateRecruitAction: 'authStore/updateRecruitAction',
      sectionOpenAction: 'authStore/sectionOpenAction',
      updateBelfastSelectedAction: 'authStore/updateBelfastSelectedAction',
      updateApplicationCompleteAction: 'authStore/updateApplicationCompleteAction',
      whereBeenValidatedAction: 'authStore/whereBeenValidatedAction'
    }),
    handleInput (input, e, nested) {
      // handle nested input
      const nestedItem = {
        category: 'whereBeen',
        input
      }
      this.updateForm(nestedItem, e, nested)
    },
    updateForm
  }
}
</script>

<style scoped>

</style>